export type TariffeItem = { duration: string; price: string };

export function parseTariffeString(tariffe: string): TariffeItem[] {
  if (!tariffe || typeof tariffe !== 'string') return [];
  return tariffe.split(',').map(raw => {
    const [duration, price] = raw.split('|');
    return {
      duration: duration?.trim() || '',
      price: price?.trim() || ''
    };
  }).filter(t => t.duration && t.price);
}
